import React from 'react';

interface ExpandCollapseProps {
  open: boolean;
  children: React.ReactNode;
  className?: string;
}

/**
 * Height-aware reveal: the panel falls down on open and rises back on close.
 * Uses 0fr → 1fr so the animation matches the content height without measuring.
 */
const ExpandCollapse: React.FC<ExpandCollapseProps> = ({
  open,
  children,
  className = '',
}) => (
  // min-h-0 matters inside flex parents (a button's content box is one in
  // Chrome), otherwise the collapsed row keeps reserving the content height.
  <div
    className={`grid min-h-0 transition-[grid-template-rows] duration-300 ease-out motion-reduce:transition-none ${
      open ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'
    } ${className}`}
  >
    <div className="overflow-hidden" aria-hidden={!open}>
      <div
        className={`transition-[opacity,transform] duration-300 ease-out motion-reduce:transition-none ${
          open ? 'translate-y-0 opacity-100' : '-translate-y-1 opacity-0'
        }`}
      >
        {children}
      </div>
    </div>
  </div>
);

export default ExpandCollapse;
